export default __webpack_public_path__ + "static/media/chevron-next.0955b961.svg";